import React, { useState } from "react";
import styles from "./LandscapeView.module.css";
import LandscapeGameCard from "./LandscapeGameCard";
import JokerHorizontalList from "./JokerHorizontalList";

interface LandscapeViewProps {
  list: any[];
  onClick?: (type: string) => void;
}

const LandscapeView: React.FC<LandscapeViewProps> = ({ list, onClick }) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <>
      <div className={styles[`mobile-view`]}>
        <JokerHorizontalList
          items={list}
          isBlurEffectEnable={true}
          showArrowIndicator={false}
          showScrollbar={false}
          isDotIndicatorConditional
          renderItem={(game: any, index, isHovered) => (
            <LandscapeGameCard
              key={index}
              title={game.title}
              description={game.description}
              video={game.video}
              indicatorVideo={game.indicator}
              isHovered={isHovered}
              images={game.image}
              onClick={onClick}
              type={game.type}
            />
          )}
        />
      </div>
      <div className={styles[`desktop-view`]}>
        {list.map((game, index) => (
          <div
            key={index}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <LandscapeGameCard
              key={index}
              title={game.title}
              description={game.description}
              video={game.video}
              indicatorVideo={game.indicator}
              isHovered={hoveredIndex === index}
              images={game.image}
              onClick={onClick}
              type={game.type}
            />
          </div>
        ))}
      </div>
    </>
  );
};
export default LandscapeView;
